import { Icon, Paragraph } from '@zillow/constellation-10';
import { IconExternalFilled } from '@zillow/constellation-icons';
import { urlUtils } from '@zg-rentals/rental-manager-env';
import {
  StyledAdCard,
  StyledAdHeader,
  StyledAdLink,
  StyledAdSubHeader,
  StyledAdTextContent,
  StyledBrandImage,
  StyledCtaButton,
  StyledEhoLogo,
  StyledHeaderOverlay,
  StyledLogo,
  StyledSlugOverlay,
} from './StyledComponents';

export interface DfpPreviewCustomFlagProps {
  templateValues: Record<string, string>;
}

// Keep in sync with https://admanager.google.com/7449#creatives/custom_native_style/detail/styleid=270429
export const DfpPreviewCustomFlag = ({ templateValues }: DfpPreviewCustomFlagProps) => {
  const href = templateValues.DestinationUrl ? urlUtils.addProtocol(templateValues.DestinationUrl) : '#';
  let { ListHeaderText } = templateValues;
  if (templateValues.ListHeaderText === 'Custom') {
    ListHeaderText = templateValues.TextHeaderCustom;
  } else if (templateValues.ListHeaderText === '') {
    ListHeaderText = 'For Rent';
  }
  return (
    <div className="DfpPreviewCustomFlag">
      <div id={`logo${templateValues.ListDisplayLogo}`}>
        <div className="container">
          <StyledAdCard>
            <StyledAdLink href={href} target="_blank" rel="noopener noreferrer" id="clickthru">
              <StyledBrandImage style={{ backgroundImage: `url(${templateValues.ImageBrandRectangle})` }}>
                <StyledSlugOverlay>Sponsored</StyledSlugOverlay>
                <StyledHeaderOverlay>{ListHeaderText}</StyledHeaderOverlay>
                {templateValues.ListDisplayEHOImage === 'yes' && <StyledEhoLogo />}
              </StyledBrandImage>
              <StyledAdTextContent>
                {templateValues.TextHeader && (
                  <Paragraph css={{ marginBlockStart: 'xs' }} textStyle="body-bold">
                    {templateValues.TextHeader}
                  </Paragraph>
                )}
                <StyledAdHeader>{templateValues.TextSubheader01}</StyledAdHeader>
                <StyledAdSubHeader>{templateValues.TextSubheader02}</StyledAdSubHeader>
                <StyledAdSubHeader>{templateValues.TextSubheader03}</StyledAdSubHeader>
                <StyledCtaButton asChild>
                  <a>
                    {templateValues.TextCTA}
                    <Icon css={{ marginInlineStart: 'xs' }}>
                      <IconExternalFilled />
                    </Icon>
                  </a>
                </StyledCtaButton>
                {templateValues.ImageLogo && (
                  <StyledLogo>
                    <img
                      id="logoSrc"
                      src={templateValues.ImageLogo}
                      alt=""
                      style={{ position: 'absolute', bottom: '5px', right: '10px' }}
                    />
                  </StyledLogo>
                )}
              </StyledAdTextContent>
            </StyledAdLink>
          </StyledAdCard>
        </div>
      </div>
    </div>
  );
};
